'use strict';
var parent = require('../../stable/instance/keys');

module.exports = parent;
